var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['wysiwyg', _vm.mergeProps.size ? ("typo--" + (_vm.mergeProps.size)) : null],domProps:{"innerHTML":_vm._s(_vm.mergeProps.value)}})}
var staticRenderFns = []

export { render, staticRenderFns }